module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"showFeedback":"Show full feedback","modalTitle":"Detail View of a Feedback"},"de":{"showFeedback":"Ganzes Feedback anzeigen","modalTitle":"Detailansicht eines Feedbacks"},"fr":{"showFeedback":"Afficher la réaction","modalTitle":"Vue détaillée d\u0027une réaction"},"it":{"showFeedback":"Mostra il feedback","modalTitle":"Visualizzazione dettagliata di un feedback"}}')
  delete Component.options._Ctor
}
